module.exports = __webpack_public_path__ + "img/448.fb693387.png";